import React, { useState, useEffect } from 'react';
import Header from 'pages/Header/HeaderNavegacion';
import Footer from 'pages/Footer/FooterDesktop';

import BarraCP from 'components/BarCP/BarHeaderCP';
import Loading from 'components/Loading';

import { decodeStorage } from 'functions/storageBase64';
import { Link } from 'react-router-dom';
import { useLogout } from 'hooks/useLogin';

import './style.sass';
import { useIsMobile } from 'hooks/useIsMobile';
import { useUserInfo } from 'hooks/usePersonalData'
import { MenuMiCuenta } from 'components/MenuMiCuenta';
import { BASE_PORTAL } from 'constants/general';

export function CardMyAccount(props) {

    const {
        ico,
        title,
        linksNav,
        internalList,
        actionClick
    } = props;

    useEffect(()=>{
        document.body.classList.remove('is-dark-mode')
    },[])

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'My Account');
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="cardMyAccount">
            <p className="titleMyAccount">
                <span className={`imgMyAccount ${ico}`}></span>
                <span className="text">{title}</span>
            </p>
            {internalList &&
                <ul className="contList">
                    {
                        internalList.map(({ url, type, text }, index) => {
                            return (
                                type === "link"
                                    ? <Link key={index} className="link" to={url}>{text}</Link>
                                    : type === "anchor"
                                        ? <a key={index} className="link" href={url} rel="noopener noreferrer">{text}</a>
                                        : type === "div"
                                            ? <p key={index} onClick={actionClick}>{text}</p>
                                            : null
                            )
                        }
                        )
                    }
                </ul>
            }
            {linksNav &&
                <div className="contLinks">
                    {
                        linksNav.map(({ url, type, text }, index) => {
                            return (
                                type === "link"
                                    ? <Link key={index} className="link" to={url}>{text}</Link>
                                    : type === "anchor"
                                        ? <a key={index} className="link" href={url} rel="noopener noreferrer">{text}</a>
                                        : type === "div"
                                            ? <div key={index} className="link" onClick={actionClick}>{text}</div>
                                            : null
                            )
                        }
                        )
                    }
                </div>
            }
        </div>
    )
}

export default function MiCuenta() {

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        window.ineum('page', 'My Account Page');
    }, [])

    const { isMobile } = useIsMobile();

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <MiCuentaDesktop />
                    : isMobile === 'movile'
                        ? null
                        : <MiCuentaMobile />
                : null
            }
        </>
    )
}

export function MiCuentaMobile() {
    const codigoP = decodeStorage('codigoPostal');
    const [codigoPostal, setCodigoPsotal] = useState(codigoP);
    const [loading, ] = useState(false);
    const { profileGet:profileData } = useUserInfo();

    useEffect(() => {
        //setLoading(false)
    }, [codigoPostal])

    useEffect(()=>{
        document.body.classList.remove('is-dark-mode')
    },[])

    //recibe la direccion del CP
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
        }
    }, [upCP, updateCPBar])

    const storageActivo = decodeStorage("activarNotificaciones");

    useEffect(() => { }, [storageActivo])

    return (
        <>
            {loading && <Loading />}
            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} headerEnCategoria={"headerListaDeseos"} tituloPagina="Mi Cuenta" />

            <main>
                <section className="miCuentaContainerMobile">
                    <div className="headerMiCuentaRed">
                        <p className="nameC">¡Hola {profileData.nombre}!</p>
                        <p className="correoC"> {profileData.correo}</p>
                    </div>
                    <MenuMiCuenta />
                </section>
            </main>
        </>
    )
}

export function MiCuentaDesktop() {
    const codigoP = decodeStorage('codigoPostal');
    const [codigoPostal, setCodigoPsotal] = useState(codigoP);
    const [loading, ] = useState(false);
    //const [profileData] = useStorage64('profileData', '');
    const { profileGet:profileData } = useUserInfo()
    const { logOut } = useLogout()

    useEffect(() => {
        //setLoading(false)
    }, [codigoPostal])

    //recibe la direccion del CP
    const [updateCPBar, setUpdateCPBar] = useState();
    const changeDirectionBar = (val) => {
        setCodigoPsotal(val);
        setUpdateCPBar(val);
    };
    const [upCP, setUpCP] = useState();
    useEffect(() => {
        if (upCP) {
            //console.log('')
        }
    }, [upCP, updateCPBar])


    const storageActivo = decodeStorage("activarNotificaciones");

    useEffect(() => { }, [storageActivo])

    return (
        <>
            {loading && <Loading />}

            <Header setUpCP={setUpCP} changeDirectionBar={changeDirectionBar} />
            <section className="barCpResponsive">
                <BarraCP changeCP={changeDirectionBar} clase="barHeaderCP" />
            </section>

            <main>
                <section className="miCuentaContainer">
                    <div className="container miCuentaBox">
                        <h1>Mi Cuenta</h1>

                        <div className="content myAccountContent">
                            <CardMyAccount
                                ico='boxPerfil'
                                title='Mi Perfil'
                                internalList={[{ "type": "div", "text": `Nombre: ${profileData.nombre}` }]}
                                linksNav={[{ "type": "div", "text": "Cerrar sesión" }]}
                                actionClick={logOut}
                            />

                            <CardMyAccount
                                ico='boxDirecciones'
                                title='Mis direcciones de envío'
                                internalList={[{ "type": "div", "text": "Ver y editar tu información de envíos." }]}
                                linksNav={[{ "type": "link", "url": "/mi-cuenta/direcciones-envio/", "text": "Ver todo" }]}
                            />


                            <CardMyAccount
                                ico='boxCredito'
                                title='Mi crédito SEARS'
                                linksNav={[{ "type": "anchor", "url": BASE_PORTAL+"/Credito-Sears/", "text": "Ver todo" }]}
                            />

                            <CardMyAccount
                                ico='boxPedidos'
                                title='Mis Pedidos'
                                content={['Ver todos mis pedidos']}
                                internalList={[{ "type": "div", "text": "Ver todos mis pedidos" }]}
                                linksNav={[{ "type": "link", "url": "/mi-cuenta/mis-pedidos/dias=30/pagina=1", "text": "Ver todo" }]}
                            />

                            <CardMyAccount
                                ico='boxDeseos'
                                title='Mi lista de deseos'
                                linksNav={[{ "type": "link", "url": "/mi-cuenta/listadeseos/", "text": "Ver todo" }]}
                            />

                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}